import clsx from "clsx";
import { appDetails } from "~/utils/misc";

function Office({
  name,
  children,
  invert = false,
}: {
  name: string;
  children: React.ReactNode;
  invert?: boolean;
}) {
  return (
    <address
      className={clsx(
        "text-sm not-italic",
        invert ? "text-neutral-300" : "text-neutral-600"
      )}
    >
      <strong className={invert ? "text-white" : "text-neutral-950"}>
        {name}
      </strong>
      <br />
      {children}
    </address>
  );
}

export function Offices({
  invert = false,
  ...props
}: React.ComponentPropsWithoutRef<"ul"> & { invert?: boolean }) {
  return (
    <ul role="list" {...props}>
      {appDetails.companies.map((company, idx) => {
        return (
          <li key={idx}>
            <Office name={company.legalName} invert={invert}>
              {company.address} <br />
              {company.registrationStatement}
            </Office>
          </li>
        );
      })}
    </ul>
  );
}
